/**
 * Open the native datetime picker (needed on some Android Chrome builds
 * where tapping the field only selects date segments instead of opening the UI).
 * Must run from a user gesture.
 */
export function openNativeDateTimePicker(event) {
  const input = event && event.currentTarget
  if (!input || input.disabled || typeof input.showPicker !== 'function') {
    return
  }
  try {
    input.showPicker()
  } catch (_) {
    // Already open, or browser blocked the call — ignore
  }
}
